import React from 'react';
import './DashboardAppBar.scss';
import { FaPlusCircle, FaUndo, FaFileDownload, FaSave } from 'react-icons/fa';
import { LogoSmallSVG } from '../layout/Logo';
import { ToolTipText } from '../layout/ToolTip';

interface DashboardAppBarProps {
  title: string;
  addClick: () => any;
  refreshClick: () => any;
  toggleDarkMode?: () => any;
  downloadHandler: () => any;
  saveHandler: () => any;
}

const DashboardAppBar: React.FC<DashboardAppBarProps> = React.memo(
  ({ title, addClick, refreshClick, downloadHandler, saveHandler }) => {
    return (
      <div className="id-bg-gray-800 id-p-0 id-shadow-lg id-border-b id-text-white id-align-middle id-flex id-justify-between">
        <div className="id-flex id-w-2/5 md:id-w/2/3">
          <div className="id-text-white id-px-2 id-self-center id-uppercase id-w-12">
            <LogoSmallSVG color={'#fff'} />
          </div>

          <h3 className="id-font-light id-text-xl id-px-2 id-self-center id-text-left id-uppercase id-w-full">
            {`${(title ? title : 'Operations').toUpperCase()}`}
          </h3>
        </div>

        <div className="id-w-3/5 md:id-w-1/3 id-self-end id-text-right">
          <ToolTipText tooltip="Add new card">
            <button
              onClick={addClick}
              className="id-appbar-btn id-bg-white hover:id-bg-gray-200 id-text-gray-800 id-font-bold id-py-2 id-px-4 id-m-2 id-border id-border-gray-400 id-rounded id-shadow"
            >
              <FaPlusCircle />
            </button>
          </ToolTipText>
          <ToolTipText tooltip="Reset Layout">
            <button
              onClick={refreshClick}
              className="id-appbar-btn id-bg-white hover:id-bg-gray-200 id-text-gray-800 id-font-bold id-py-2 id-px-4 id-m-2 id-border id-border-gray-400 id-rounded id-shadow"
            >
              <FaUndo />
            </button>
          </ToolTipText>
          <ToolTipText tooltip="Download JSON">
            <button
              onClick={downloadHandler}
              className="id-appbar-btn id-bg-white hover:id-bg-gray-200 id-text-gray-800 id-font-bold id-py-2 id-px-4 id-m-2 id-border id-border-gray-400 id-rounded id-shadow"
            >
              <FaFileDownload />
            </button>
          </ToolTipText>
          <ToolTipText tooltip="Save Layout">
            <button
              onClick={saveHandler}
              className="id-appbar-btn id-bg-white hover:id-bg-gray-200 id-text-gray-800 id-font-bold id-py-2 id-px-4 id-m-2 id-border id-border-gray-400 id-rounded id-shadow"
            >
              <FaSave />
            </button>
          </ToolTipText>
        </div>
      </div>
    );
  }
);

export default DashboardAppBar;
